// src/types/label.types.ts

// src/types/label.types.ts

export enum ClinicalLabel {
  SAUDAVEL = 'SAUDAVEL',
  ESTENOSE_AORTICA = 'ESTENOSE_AORTICA',
  INSUFICIENCIA_AORTICA = 'INSUFICIENCIA_AORTICA',
  ESTENOSE_MITRAL = 'ESTENOSE_MITRAL',
  ESTENOSE_TRICUSPIDE = 'ESTENOSE_TRICUSPIDE',
  ESTENOSE_PULMONAR = 'ESTENOSE_PULMONAR',
  INSUFICIENCIA_MITRAL = 'INSUFICIENCIA_MITRAL',
  INSUFICIENCIA_TRICUSPIDE = 'INSUFICIENCIA_TRICUSPIDE',
  INSUFICIENCIA_PULMONAR = 'INSUFICIENCIA_PULMONAR',
  OUTROS = 'OUTRA_PATOLOGIA',
}

export const ClinicalLabelNames: Record<ClinicalLabel, string> = {
  [ClinicalLabel.SAUDAVEL]: 'Saudável',
  [ClinicalLabel.ESTENOSE_AORTICA]: 'Estenose Aórtica',
  [ClinicalLabel.ESTENOSE_MITRAL]: 'Estenose Mitral',
  [ClinicalLabel.ESTENOSE_TRICUSPIDE]: 'Estenose Tricúspide',
  [ClinicalLabel.ESTENOSE_PULMONAR]: 'Estenose Pulmonar',
  [ClinicalLabel.INSUFICIENCIA_AORTICA]: 'Insuficiência Aórtica',
  [ClinicalLabel.INSUFICIENCIA_MITRAL]: 'Insuficiência Mitral',
  [ClinicalLabel.INSUFICIENCIA_TRICUSPIDE]: 'Insuficiência Tricúspide',
  [ClinicalLabel.INSUFICIENCIA_PULMONAR]: 'Insuficiência Pulmonar',
  [ClinicalLabel.OUTROS]: 'Outra Patologia',
};

export interface LabelRecord {
  labelId: string;
  audioId: string;
  label: ClinicalLabel;
  protocol_version: string;
  comment?: string;
  author_uid: string;
  author_name: string;
  created_at: Date;
  replaces?: string; // ID do rótulo anterior (para versionamento)
}

export interface LabelCreate {
  audioId: string;
  label: ClinicalLabel;
  protocol_version: string;
  comment?: string;
}

export interface LabelHistory {
  labels: LabelRecord[];
  currentLabel?: LabelRecord;
}
